var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{attrs:{"id":"line-chart-" + _vm.id,"width":"2","height":"1"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }